export default {
  disclaimer: {
    summary:
      "Veuillez noter qu'il vous appartient de vérifier que toutes les devises et taxes sont exactes pour la juridiction applicable.",
    extra:
      "Nous incluons ces informations à titre indicatif uniquement et déclinons toute responsabilité quant à l'exactitude des devises et/ou taxes ou au paiement de ces taxes dans le cadre de nos produits. Les informations relatives aux devises et taxes contenues ici sont fournies à titre informatif uniquement.",
    show_more: 'Afficher plus',
    show_less: 'Afficher moins',
  },
  partner_note:
    "Ce sont vos paramètres par défaut au niveau partenaire. Les restaurants de votre compte héritent automatiquement de ces valeurs, sauf s'ils remplacent une catégorie individuellement.",
  section_title: 'Taux de taxe pour les articles du menu',
  new_category_placeholder: 'Nouvelle catégorie',
  form: {
    name: {
      label: 'Catégorie de taxe',
    },
    default_tax_rate: {
      label: 'Taux par défaut',
      tooltip: "Utilisé comme valeur de remplacement lorsqu'un taux spécifique par mode de commande est laissé vide.",
    },
    pickup_tax_rate: {
      label: 'À emporter',
    },
    delivery_tax_rate: {
      label: 'Livraison',
    },
    dine_in_tax_rate: {
      label: 'Sur place',
    },
    room_service_tax_rate: {
      label: 'Service en chambre',
    },
    show_zero_tax_in_summary: {
      label: 'Afficher la taxe à 0 % dans le récapitulatif de commande',
    },
  },
  buttons: {
    add_category: 'Ajouter une catégorie de taxe',
    cancel: 'Annuler',
    save: 'Enregistrer',
    confirm: 'Supprimer',
    delete: 'Supprimer la catégorie',
    reset: "Réinitialiser vers l'hérité",
  },
  delete_confirm: {
    title: 'Supprimer cette catégorie de taxe ?',
    description: 'Cette action est irréversible.',
  },
  scope_labels: {
    region: "À l'échelle de la région",
    partner: "À l'échelle du partenaire",
    restaurant: "À l'échelle du restaurant",
  },
  confirm_modal: {
    title: {
      fork: 'Transformer en catégorie propre à ce restaurant ?',
      owned: 'Appliquer les nouveaux taux ?',
      reset: 'Revenir à la catégorie héritée ?',
    },
    affected_one: '{{count}} produit ou catégorie est actuellement lié et se verra appliquer les nouveaux taux.',
    affected_other:
      '{{count}} produits et catégories sont actuellement liés et se verront appliquer les nouveaux taux.',
    affected_settings_one:
      '{{count}} produit ou catégorie est actuellement lié et utilisera les paramètres mis à jour.',
    affected_settings_other:
      '{{count}} produits et catégories sont actuellement liés et utiliseront les paramètres mis à jour.',
    restaurants_one: 'Cela représente {{count}} restaurant.',
    restaurants_other: 'Cela représente {{count}} restaurants.',
    acknowledge:
      "Je comprends qu'en confirmant, la catégorie de taxe change pour tous les produits actuellement liés à cette catégorie",
    impact_error: 'Échec de la vérification des produits concernés',
    cancel: 'Annuler',
    confirm: 'Confirmer',
  },
  toasts: {
    load_error: 'Impossible de charger les catégories de taxe.',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Modifications enregistrées',
    delete_error: 'Impossible de supprimer cette catégorie de taxe.',
    category_deleted: 'Catégorie de taxe supprimée',
    category_reset: 'Catégorie de taxe réinitialisée à celle héritée',
    reset_error: 'Impossible de réinitialiser cette catégorie de taxe.',
    impact_error: 'Échec de la vérification des produits concernés',
    impact_changed_one:
      'Le nombre de produits concernés est passé à {{count}}. Veuillez vérifier et confirmer à nouveau.',
    impact_changed_other:
      'Le nombre de produits concernés est passé à {{count}}. Veuillez vérifier et confirmer à nouveau.',
  },
};
